'use strict';

require('./dist/index.js');
var index = require('../../_virtual/index.js_commonjs-exports5.js');

// eslint-disable-next-line import/no-unresolved
var reactWithStylesInterfaceCss = index.__exports.default;

module.exports = reactWithStylesInterfaceCss;
